import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage,
    ValidationMessageType, SettingState, TibboDataType,
} from '@appblocks/codegeneration/types';

export default class CggTelemetry extends BaseFeature {
    constructor() {
        super();
        this.name = 'Thingsboard Telemetry';
        this.id = 'cgg_telemetry';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: 'Telemetry_Name',
            },
            {
                id: 'TELEMETRY_ID',
                name: 'ID',
                settingType: SettingType.STRING,
                required: true,
                default: 'Telemetry_ID',
            },
        ]);
    }

    getDependencies() {
        const dependencies = [
            'cgg',
        ];
        return dependencies;
    }
}
